// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { setUserId } from '@amplitude/analytics-browser';


export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    console.log("Processing auth callback...");
    const hash = window.location.hash;
    console.log("Hash is ", hash);
    const params = new URLSearchParams(hash.split("?")[1]);
    console.log("Params are ", params);
    const sessionId = params.get("session_id");
    console.log("Session ID is ", sessionId);
    if (sessionId) {
      console.log("Exchanging session ID for user info...");
      // Persist the session token as a fallback (when cookies are blocked / not set)
      try {
        window.localStorage.setItem("session_token", sessionId);
      } catch {}
      // Also set the default Authorization header on the axios instance so
      // subsequent API calls include the token until a cookie is available.
      api.defaults.headers.common["Authorization"] = `Bearer ${sessionId}`;

      api
        .post("/auth/session", { session_id: sessionId })
        .then(({ data }) => {
          setUser(data.user);
          setUserId(data.user.user_id);
          window.history.replaceState({}, "", "/");
          navigate("/", { replace: true, state: { user: data.user } });
        })
        .catch(() => {
          navigate("/", { replace: true });
        });
      return;
    }

    api
      .get("/auth/me")
      .then(({ data }) => {
        setUser(data);
        navigate("/", { replace: true, state: { user: data } });
      })
      .catch(() => {
        navigate("/", { replace: true });
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F6F0]">
      <div className="text-[#5C665F]" data-testid="auth-callback-loading">
        Signing you in…
      </div>
    </div>
  );
}
